'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Option = require('./Option.js');
var uuid = require('uuid');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Checkbox(_ref) {
  let {
    name = uuid.v4(),
    value,
    options,
    component,
    wrapperStyles = {},
    limit = options.length,
    isDisabled = false,
    onChange
  } = _ref;
  const [selectedOptions, setSelectedOptions] = React.useState(() => Array.isArray(value) && value ? value : []);
  const isMaxLimit = selectedOptions.length >= limit && limit !== 1;

  // refresh `selected` local state when `value` props changed
  React.useEffect(() => {
    setSelectedOptions(Array.isArray(value) && value ? value : []);
  }, [value]);
  const handleSelect = option => {
    const isOptionSelected = selectedOptions.some(o => o === option.value);
    const singleOption = isOptionSelected ? [] : [option.value];
    const multipleOptions = isOptionSelected ? selectedOptions.filter(o => o !== option.value) : selectedOptions.concat(!isMaxLimit ? [option.value] : []);
    const newValues = limit === 1 ? singleOption : multipleOptions;
    setSelectedOptions(newValues);
    if (onChange) onChange(newValues);
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...wrapperStyles
    }
  }, options.map(option => /*#__PURE__*/React__default["default"].createElement(Option.Option, {
    key: option.value,
    name: name,
    type: "checkbox",
    option: option,
    isSelected: selectedOptions.some(o => o === option.value),
    isDisabled: isDisabled,
    isMaxLimit: isMaxLimit,
    component: component,
    onSelect: handleSelect
  })));
}

exports.Checkbox = Checkbox;
